import { useState } from 'react'
import { Info } from 'lucide-react'
import { cn } from '@lib/utils/helpers'
import {
    DESCRIPTION_TOOLTIP_ARROW_UP,
    DESCRIPTION_TOOLTIP_SURFACE,
} from '@/lib/utils/descriptionTooltipStyles'
import { ACH_PAYMENT_FORM_HELP_TEXT } from '@/features/company/utils/paymentsTabLogic'

import type { AchPaymentFormHelperTipProps } from '@/features/company/types'

export function AchPaymentFormHelperTip({ infoButtonDataTestId }: AchPaymentFormHelperTipProps) {
    const [open, setOpen] = useState(false)
    return (
        <span
            className="relative inline-flex items-center align-middle"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            <button
                type="button"
                data-testid={infoButtonDataTestId}
                tabIndex={0}
                className="ml-0.5 rounded border-0 bg-transparent p-0 leading-none text-green-600 hover:text-green-700 focus-visible:outline focus-visible:ring-2 focus-visible:ring-green-500/40 cursor-pointer"
                aria-label="About ACH payment form"
                onFocus={() => setOpen(true)}
                onBlur={() => setOpen(false)}
            >
                <Info size={15} className="shrink-0" strokeWidth={2.25} aria-hidden />
            </button>
            {open ? (
                <div
                    role="tooltip"
                    className="absolute left-0 top-full z-[200] mt-2 min-w-[min(300px,88vw)] max-w-md text-left"
                >
                    <div className={DESCRIPTION_TOOLTIP_ARROW_UP} aria-hidden />
                    <div
                        className={cn(
                            DESCRIPTION_TOOLTIP_SURFACE,
                            'relative px-3 py-2.5 text-sm font-normal leading-snug text-slate-800',
                        )}
                    >
                        {ACH_PAYMENT_FORM_HELP_TEXT}
                    </div>
                </div>
            ) : null}
        </span>
    )
}
